import React, { useState, useEffect, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'
import Layout from '../Layout/Layout.js';
import DataTable from 'react-data-table-component';
import { APIUrl } from '../../Helper/APIUrl.js';
import { SnackbarProvider, useSnackbar } from "notistack";
import { data } from 'autoprefixer';

function ManageSubscriptionRequest() {
    const Token = JSON.parse(localStorage.getItem('tcn'));
    const UserId = JSON.parse(localStorage.getItem('userid'));

    const { enqueueSnackbar } = useSnackbar();

    const [val, setVal] = useState(0);

    const [search, setsearch] = useState("");
    const [FilterDropdown, setFilterDropdown] = useState("");
    const [lstSubscription, setlstSubscription] = useState([]);
    const [filterlstSubscription, setfilterlstSubscription] = useState([]);

    //Use Ref for Focus
    const AllowedPostCountRef = useRef(null);
    const SubscriptionExpiryDateRef = useRef(null);

    const [zsection, setzsection] = useState([]);

    //Insert and Update UseStates

    const [Username, setUsername] = useState("");
    const [Email, setEmail] = useState("");
    const [Phone, setPhone] = useState("");
    const [SubscriptionId, setSubscriptionId] = useState("");
    const [AllowedPostCount, setAllowedPostCount] = useState("");
    const [SubscriptionExpiryDate, setSubscriptionExpiryDate] = useState("");


    const [IsActive, setisactive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(UserId);
    const [CreatedOn, setCreatedOn] = useState("");
    const [ModifiedBy, setModifiedBy] = useState(UserId);
    const [ModifiedOn, setModifiedOn] = useState("");

    //Edit Populates States
    const [edit, setEdit] = useState(false);
    const [returnId, setreturnId] = useState(0);

    //API : Base Url + Controller Name
    const ConcateURL = APIUrl.Subscription;



    function doEmptyStates() {
        setAllowedPostCount("");
        setSubscriptionExpiryDate("");
        setEdit(false)
    }





    const parseJSON = async (response) => {
        try {
            if (response.status === 204 || response.status === 205) return null;
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getAllSubscriptionRequests = async () => {
        try {
            const response = await fetch(ConcateURL + 'GetAllSubscription', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({})
            });
            const result = await parseJSON(response);
            if (result?.data != null) {
                setlstSubscription(result.data);
                setlstSubscription(result.data.sort((a, b) => b.SubscriptionId - a.SubscriptionId));
                setfilterlstSubscription(result.data.sort((a, b) => b.SubscriptionId - a.SubscriptionId));
                console.log(result.data);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllSubscriptionRequests();
    }, []);


    const coloumn = [
        {
            name: "SNo.",
            selector: (row, index) => index + 1,
            width: '80px'
        },
        {
            name: "Vendor UserName & Email",
            cell: (row) => (
                <div className="py-2">
                    <div className="font-semibold text-gray-800">{row.UserName}</div>
                    <div className="text-sm text-gray-600">{row.Email}</div>
                </div>
            ),
            sortable: true,
            reorder: true,
            width: '250px'
        },
        {
            name: "Post Credits",
            selector: (row) => row.AllowedPostCount,
            width: '120px'
        },
        {
            name: "Requested Date",
            selector: (row) => new Date(row.CreatedOn).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
            sortable: true,
            width: '150px'
        },
        {
            name: "Expired Date",
            selector: (row) => row.IsWanttoUpgradeSubscription && row.IsUpgradeSubscriptionbyAdmin && row.IsActive ? new Date(row.SubscriptionExpiryDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-',
            sortable: true,
            width: '150px'
        },
        {
            name: "Status",
            selector: (row) =>
                row.IsWanttoUpgradeSubscription && !row.IsUpgradeSubscriptionbyAdmin ? (
                    <span className="px-3 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Pending</span>
                ) : row.IsWanttoUpgradeSubscription && row.IsUpgradeSubscriptionbyAdmin && row.IsActive && new Date(row.SubscriptionExpiryDate) > new Date() ? (
                    <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Active</span>
                ) : !row.IsWanttoUpgradeSubscription && !row.IsUpgradeSubscriptionbyAdmin && !row.IsActive ? (
                    <span className="px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Rejected</span>
                ) : row.IsWanttoUpgradeSubscription && row.IsUpgradeSubscriptionbyAdmin && row.IsActive && new Date(row.SubscriptionExpiryDate) < new Date() ? (
                    <span className="px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Expired</span>
                ) : null,
            width: '130px'
        },
        {
            name: "Action",
            cell: (row) =>
                row.IsWanttoUpgradeSubscription && !row.IsUpgradeSubscriptionbyAdmin && row.IsActive ? (
                    <div className="flex gap-2">
                        <Button
                            onClick={() => PopulateSubscriptionData(row.SubscriptionId)}
                            className="text-white bg-blue-600 hover:bg-blue-700 font-medium rounded-lg text-sm px-3 py-2 transition-colors"
                        >
                            Update
                        </Button>
                        <Button
                            onClick={() => RejectSubscription(row.SubscriptionId)}
                            className="text-white bg-red-600 hover:bg-red-700 font-medium rounded-lg text-sm px-3 py-2 transition-colors"
                        >
                            Reject
                        </Button>
                    </div>
                ) : null,
            width: '180px'
        }
    ];

    const PopulateSubscriptionData = async (Id) => {
        try {
            debugger;
            let items = lstSubscription.filter(x => {
                return x.SubscriptionId === Id;
            });

            items.map(item => {

                setSubscriptionId(item.SubscriptionId);
                setAllowedPostCount(item.AllowedPostCount);
                setModifiedBy(UserId);

                const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
                const currentYear = new Date().getFullYear();
                const daysToAdd = isLeapYear(currentYear) ? 365 : 364;
                setSubscriptionExpiryDate(new Date(new Date().setDate(new Date().getDate() + daysToAdd)).toISOString().split('T')[0])

                setreturnId(item.SubscriptionId)
            })

            setEdit(true)

            AllowedPostCountRef.current.focus();

        }
        catch (error) {
            console.log(error);
        }
    };

    const RejectSubscription = async (Id) => {
        try {
            // let data = { SubscriptionId: Id, IsWanttoUpgradeSubscription: false, IsUpgradeSubscriptionbyAdmin: false, IsActive: false, ModifiedBy } 
            const response = await fetch(ConcateURL + 'RejectSubscription/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllSubscriptionRequests();
                doEmptyStates();
                enqueueSnackbar("Subscription Rejected", { variant: "error" });
            }
        }
        catch (error) {
            console.log(error);
        }
    };




    const fnUpdateSubscription = async (Id) => {
        try {

            let data = { SubscriptionId, AllowedPostCount, SubscriptionExpiryDate, ModifiedBy }
            const response = await fetch(ConcateURL + 'UpdateSubscription/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllSubscriptionRequests();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" });
            }
        }
        catch (error) {
            console.log(error);
        }
    };




    useEffect(() => {
        const result = lstSubscription.filter(x => {
            return x.UserName?.toLowerCase().includes(search.toLowerCase()) ||
                x.Email?.toLowerCase().includes(search.toLowerCase()) ||
                x.FullName?.toLowerCase().includes(search.toLowerCase()) ||
                x.Company?.toLowerCase().includes(search.toLowerCase()) ||
                x.OfficeNumber?.toLowerCase().includes(search.toLowerCase()) ||
                x.Description?.toLowerCase().includes(search.toLowerCase()) ||
                x.Position?.toLowerCase().includes(search.toLowerCase()) ||
                x.OfficeAddress?.toLowerCase().includes(search.toLowerCase()) ||
                x.JobProfile?.toLowerCase().includes(search.toLowerCase()) ||
                x.Phone?.toLowerCase().includes(search.toLowerCase()) ||
                x.PersonalAddress?.toLowerCase().includes(search.toLowerCase()) ||
                x.Facebook?.toLowerCase().includes(search.toLowerCase()) ||
                x.Twitter?.toLowerCase().includes(search.toLowerCase()) ||
                x.Linkdin?.toLowerCase().includes(search.toLowerCase());
        })
        setfilterlstSubscription(result);
    }, [search]);


    useEffect(() => {
        if (FilterDropdown == "pending") {
            const result = lstSubscription.filter(x => x.IsWanttoUpgradeSubscription && !x.IsUpgradeSubscriptionbyAdmin);
            setfilterlstSubscription(result);
        }
        else if (FilterDropdown == "approved") {
            const result = lstSubscription.filter(x => x.IsWanttoUpgradeSubscription && x.IsUpgradeSubscriptionbyAdmin && x.IsActive && new Date(x.SubscriptionExpiryDate) > new Date());
            setfilterlstSubscription(result);
        }
        else if (FilterDropdown == "rejected") {
            const result = lstSubscription.filter(x => !x.IsWanttoUpgradeSubscription && !x.IsUpgradeSubscriptionbyAdmin && !x.IsActive);
            setfilterlstSubscription(result);
        }
        else if (FilterDropdown == "expired") {
            const result = lstSubscription.filter(x => x.IsWanttoUpgradeSubscription && x.IsUpgradeSubscriptionbyAdmin && x.IsActive && new Date(x.SubscriptionExpiryDate) < new Date());
            setfilterlstSubscription(result);
        }
        else {
            setfilterlstSubscription(lstSubscription);
        }
    }, [FilterDropdown]);


    const tableData = { coloumn, filterlstSubscription };


    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">
                        <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                            <div>
                                <h2 className="text-xl font-semibold text-pink-900 mb-6">Subscription Overview</h2>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
                                <div onClick={() => setFilterDropdown("pending")} style={{ cursor: 'pointer' }}>
                                    <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg p-6 border border-yellow-200 hover:shadow-lg transition-shadow">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-yellow-800">Pending Subscriptions</p>
                                                <p className="text-3xl font-bold text-yellow-600 mt-2">
                                                    {lstSubscription.filter(x => x.IsWanttoUpgradeSubscription && !x.IsUpgradeSubscriptionbyAdmin).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-yellow-400">⏳</div>
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => setFilterDropdown("approved")} style={{ cursor: 'pointer' }}>
                                    <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6 border border-green-200 hover:shadow-lg transition-shadow">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-green-800">Approved Subscriptions</p>
                                                <p className="text-3xl font-bold text-green-600 mt-2">
                                                    {lstSubscription.filter(x => x.IsWanttoUpgradeSubscription && x.IsUpgradeSubscriptionbyAdmin && x.IsActive && new Date(x.SubscriptionExpiryDate) > new Date()).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-green-400">✓</div>
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => setFilterDropdown("rejected")} style={{ cursor: 'pointer' }}>
                                    <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-6 border border-red-200 hover:shadow-lg transition-shadow">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-red-800">Rejected Subscriptions</p>
                                                <p className="text-3xl font-bold text-red-600 mt-2">
                                                    {lstSubscription.filter(x => !x.IsWanttoUpgradeSubscription && !x.IsUpgradeSubscriptionbyAdmin && !x.IsActive).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-red-400">✕</div>
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => setFilterDropdown("expired")} style={{ cursor: 'pointer' }}>
                                    <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-lg p-6 border border-pink-200 hover:shadow-lg transition-shadow">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-pink-800">Expired Subscriptions</p>
                                                <p className="text-3xl font-bold text-pink-600 mt-2">
                                                    {lstSubscription.filter(x => x.IsWanttoUpgradeSubscription && x.IsUpgradeSubscriptionbyAdmin && x.IsActive && new Date(x.SubscriptionExpiryDate) < new Date()).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-pink-400">⌛</div>
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => setFilterDropdown("")} style={{ cursor: 'pointer' }}>
                                    <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6 border border-blue-200 hover:shadow-lg transition-shadow">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-blue-800">Manage All Requests</p>
                                                <p className="text-3xl font-bold text-blue-600 mt-2">
                                                    {lstSubscription.length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-blue-400">📊</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {
                            edit == true && (
                                <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                                    <h2 className="text-xl font-semibold text-pink-900 mb-6">
                                        Manage Subscription Requests
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-pink-700 mb-2">
                                                Post Credits
                                            </label>
                                            <input
                                                type="text"
                                                id="name"
                                                ref={AllowedPostCountRef}
                                                value={AllowedPostCount}
                                                onChange={(e) => { setAllowedPostCount(e.target.value) }}
                                                placeholder="Enter Post Credits"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-pink-700 mb-2">
                                                Subscription Expiry Date
                                            </label>
                                            <input
                                                type="date"
                                                id="name"
                                                disabled={true}
                                                ref={SubscriptionExpiryDateRef}
                                                value={SubscriptionExpiryDate}
                                                onChange={(e) => { setSubscriptionExpiryDate(e.target.value) }}
                                                placeholder="Enter Subscription Expiry Date"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-col sm:flex-row gap-4 mt-3">
                                        {
                                            edit == true ?
                                                <Button
                                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                                    onClick={() => fnUpdateSubscription(returnId)}
                                                >
                                                    <span>Update</span>
                                                </Button> : null
                                        }

                                        <button
                                            type="button"
                                            onClick={() => doEmptyStates()}
                                            className="px-6 py-3 bg-pink-600 text-white font-medium rounded-lg hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2 transition-colors duration-200"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            )
                        }



                        <div className="bg-white rounded-xl shadow-sm border border-pink-200 overflow-hidden">
                            <div class="overflow-x-auto">
                                <DataTable
                                    title="All Subscription Requests"
                                    columns={coloumn}
                                    data={filterlstSubscription}
                                    pagination
                                    fixedHeader
                                    fixedHeaderScrollHeight="550px"
                                    selectableRows
                                    selectableRowsHighlight
                                    highlightOnHover
                                    // actions={<button className="btn btn-sm btn-info">Export</button>}                                                
                                    subHeader
                                    subHeaderAlign="right"
                                    subHeaderComponent={
                                        <>
                                            <input type="text"
                                                placeholder="search username"
                                                className="w-full sm:w-64 px-4 py-2 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                value={search}
                                                onChange={(e) => setsearch(e.target.value)}
                                            />

                                        </>
                                    }
                                />
                            </div>
                        </div>
                    </div>


                </main>
            </Layout >

        </div >
    )
}

export default ManageSubscriptionRequest